import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as techApi from '../../lib/api/tech';

const [LIST_RSLTS_TECHS, LIST_RSLTS_TECHS_SUCCESS, LIST_RSLTS_TECHS_FAILURE] =
  createRequestActionTypes('chance/LIST_RSLTS_TECHS');

export const listRsltTechs = createAction(
  LIST_RSLTS_TECHS,
  (searchData) => searchData,
);
const listRsltTechsSaga = createRequestSaga(
  LIST_RSLTS_TECHS,
  techApi.getRsltTechs,
);

const UNLOAD_RSLTS_TECHS = 'chance/UNLOAD_RSLTS_TECHS';
export const unloadRsltTechs = createAction(UNLOAD_RSLTS_TECHS);

export function* rsltTechsSaga() {
  yield takeLatest(LIST_RSLTS_TECHS, listRsltTechsSaga);
}

const initialState = {
  techs: null,
  error: null,
};

const rlstTechs = handleActions(
  {
    [LIST_RSLTS_TECHS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      techs: data.list.map((tech) => ({
        id: tech.reqUuid,
        rsltUuid: tech.rsltUuid,
        rsltNo: tech.rsltNo,
        reqUuid: tech.reqUuid,
        prjUuid: tech.prjUuid,
        rsltStatus:tech.rsltStatus,
        rsltTyp: tech.rsltTyp,
        rsltTitle: tech.rsltTitle,
        rsltStrtDt: tech.rsltStrtDt,
        rsltStrtTm: tech.rsltStrtTm,
        rsltEndDt: tech.rsltEndDt,
        rsltEndTm: tech.rsltEndTm,
        rsltTotTm: tech.rsltTotTm,
        crtNm: tech.crtNm,
        crtDt: tech.crtDt,
        cngNm: tech.cngNm,
        cngDt: tech.cngDt,
      })),
      error: null,
    }),
    [LIST_RSLTS_TECHS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_RSLTS_TECHS]: () => initialState,
  },
  initialState,
);

export default rlstTechs;
